export default __webpack_public_path__ + "static/media/logo.75c4e727.png";